export const ENTITY_NAME = 'Compute';
export const COMPUTE_RESOURCE = 'Compute resource';
export const PAGE_TITLES = {
    create: `Register a compute resource`,
    view: `View compute resource`,
    list: `Manage compute resources`,
};
export var AuthenticationType;
(function (AuthenticationType) {
    AuthenticationType["ManagedIdentity"] = "ManagedIdentity";
    AuthenticationType["ServicePrincipal"] = "ServicePrincipal";
    AuthenticationType["Legacy"] = "Legacy";
})(AuthenticationType || (AuthenticationType = {}));

//# sourceMappingURL=ComputeResource.constants.js.map
